<template>
  <div>
    <!-- Menu and Filters -->
    <div v-if="loadingOverlay === true">
      <div class="lds-dual-ring"></div>
    </div>
    <div v-else>
      <!-- Summary and Filters -->
      <div class="row">
        <div class="col-md-3" >
          <h4>Total Earnings 
            {{ new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(earningsStore.summary.totalEarnings) }}
          </h4>
        </div>
        <div class="col-md-9">
          <div style="padding: 10px; margin-top: 10px; float: right">
            <p-button color="success" class="mr-4" @click="search">
              Select
            </p-button>
          </div>
          <div style="padding: 10px; float: right">
            Ending
            <datepicker v-model="pickerEnd" placeholder="Select Date:" name="campaignStart"
              input-class="calendar-input-analytics" format="M/d/yy" :use-utc="true"/>
          </div>
          <div style="padding: 10px; float: right">
            Starting
            <datepicker v-model="pickerStart" placeholder="Select Date:" name="datStart"
              input-class="calendar-input-analytics" format="M/d/yy" :use-utc="true"/>
          </div>
        </div>
      </div>

      <!-- Request Payout -->
      <!-- <div class="row">
        <div class="col-md-12">
          <p-button @click="search" round outline type="info" size="xl"
            style="margin-bottom: 40px;float: left">Request Payout</p-button>
        </div>
      </div> -->

      <!-- Earnings -->
      <div class="row">
        <div class="col-md-12">
          <div class="card" style="padding-left: 15px">
            <div class="card-header">
              <h5 class="title" v-if="earningsStore.result.length > 0">{{ earningsStore.summary.earningsEvents }} Earnings</h5>
              <h5 class="title" v-else>No Earnings</h5>
            </div>
            <div v-if="earningsStore.result.length > 0">
              <b-table id="order-stats-table" :items="earningsStore.result" :fields="columns" :current-page="currentPage" :per-page="perPage"
                :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" :busy.sync="isLoading">
                <template #table-busy>
                  <div class="text-center" style="margin-top: 10px">
                    <b-spinner class="align-middle" style="margin-right: 10px"></b-spinner>
                    <strong>Loading...</strong>
                  </div>
                </template>
                <!-- Date -->
                <template #cell(date)="row">
                  <div style="width: 100%; text-align: center">{{ convertTimestampToDate(row.item.lastUpdated) }}</div>
                </template>
                <!-- Earnings -->
                <template #cell(earnings)="row">
                  <div style="width: 100%; text-align: center">
                    {{ new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(row.item.earnings) }}
                  </div>
                </template>
                <!-- Brand -->
                <template #cell(brand)="row">
                  <div style="width: 100%; text-align: center">{{ row.item.clientName }}</div>
                </template>
                <!-- Campaign -->
                <template #cell(campaign)="row">
                  <div style="width: 100%; text-align: center">{{ row.item.campaignName }}</div>
                </template>
                <!-- Status -->
                <template #cell(status)="row">
                  <div style="width: 100%; text-align: center">{{ row.item.status }}</div>
                </template>
              </b-table>
              <!-- Pagination -->
              <b-col style="width: 500px;padding: 20px;text-align: center;margin: auto">
                <b-pagination v-model="currentPage" :disabled="isLoading" :total-rows="earningsStore.summary.earningsEvents" :per-page="perPage" align="fill"
                  size="sm" class="my-0"/>
              </b-col>
            </div>
          </div>
          <!-- Rows Table -->
          <div style="padding: 10px; float: left">
            Rows
            <select v-model="perPage" class="custom-select">
              <option v-for="option in ['25', '50']" :value="option" :key="option">
                {{ option }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import firebase from 'firebase'
import store from '@/store/index.js'
import { mapGetters } from 'vuex'
import Datepicker from 'vuejs-datepicker'
import { userLoadApi } from '@/config/appSettings'
import { convertTimestampToDate } from '@/util/date'

export default {
  name: 'Earnings',
  components: { Datepicker },
  data() {
    return {
      loadingOverlay: false,
      pickerStart: null,
      pickerEnd: null,
      columns: [
        { key: 'date', label: 'Date', sortable: false, class: 'text-center' },
        { key: 'earnings', label: 'Earnings', sortable: false, class: 'text-center' },
        { key: 'brand', label: 'Brand', sortable: true, class: 'text-center' },
        { key: 'campaign', label: 'Campaign', sortable: true, class: 'text-center' },
        { key: 'status', label: 'Status', sortable: true, class: 'text-center' },
      ],
      isLoading: false,
      currentPage: 1,
      perPage: 25,
      sortBy: 'date',
      sortDesc: true,
      sortDirection: 'asc',
      userId: ''
    }
  },
  created() {
    this.loadingOverlay = true
    this.search()
  },
  computed: { ...mapGetters(["earningsStore"]) },
  methods: {
    async search() {
      this.isLoading = true
      let user = await axios.get(`${userLoadApi}${firebase.auth().currentUser.uid}`)
      if (user.data.success === true && this.userId == '') {
        this.userId = user.data.result.activeId
      }      
      store.dispatch('getAllInfluencerEarnings', {
        userId: this.userId,
        startDate: this.pickerStart, 
        endDate: this.pickerEnd 
      }).then(() => {
        this.isLoading = false
        this.loadingOverlay = false
      })
    },
    convertTimestampToDate(date) {
      return convertTimestampToDate(date * 1000)
    }    
  }
}
</script>